import { useDroppable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { useState } from "react";
import React from "react";
import AppTopBar, { AppNavBar, renderers } from "./Elements";

interface FieldProps extends React.HTMLAttributes<HTMLDivElement> {
  field: { type: string };
  overlay?: boolean;
}

interface SortableFieldProps {
  id: string;
  index: number;
  field: { type: string };
}

interface CanvasProps {
  fields: { id: string; type: string }[];
}

function getRenderer(type: string): React.FC<any> {
  if (type === "spacer") {
    return () => <div className="spacer">spacer</div>;
  }
  return renderers[type] || (() => <div>No renderer found for {type}</div>);
}

export const Field = React.forwardRef<HTMLDivElement, FieldProps>(
  ({ field, overlay, style, ...rest }, ref) => {
    const { type } = field;
    const Component = getRenderer(type);

    let className = `canvas-field ${type}`;
    if (overlay) className += " overlay";

    return (
      <div ref={ref} className={className} style={style} {...rest}>
        <Component />
      </div>
    );
  }
);

function SortableField({ id, index, field }: SortableFieldProps) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id,
      data: { index, id, field },
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Field field={field} ref={setNodeRef} style={style} {...attributes} {...listeners}/>
  );
}

function DisabledSortableField({ id, index, field }: SortableFieldProps) {

  const Component = getRenderer(field.type);

  return (
    <div className={field.type}>
      <Component />
    </div>
  );
}

interface CanvasProps {
  fields: { id: string; type: string }[];
  navFields: { id: string; type: string }[];
  appBarPreview: string;
}

export default function MoreCanvas({ fields, navFields, appBarPreview }: CanvasProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: "canvas_droppable",
    data: { parent: null, isContainer: true },
  });

  return (
    <div ref={setNodeRef} className={`canvas ${isOver ? "over" : ""}`}>
      <div className="device">
        <AppTopBar appBarPreview={appBarPreview} />
        <s>Speaker</s>
        <b>Camera</b>
        <div className="screen app-more">
          <div className="canvas-fields flex">
            {fields?.map((f, i) => (
              <SortableField key={f.id} id={f.id} field={f} index={i} />
            ))}
          </div>
        </div>
        <div className="navbar">
          <div className="icon-box ">
            <i className="fas fa-home"></i>Home
          </div>
          {navFields?.map((f, i) => (
            <DisabledSortableField key={f.id} id={f.id} field={f} index={i} />
          ))}
          <div className="icon-box  active">
            <i className="fas fa-plus-circle"></i>Mais
          </div>
        </div>
      </div>
    </div>
  );
}